'use client';

import { useState } from 'react';

const FAQ_DATA = [
  {
    question: 'Is the guide really free?',
    answer:
      "Yes, completely free. Just enter your email and we'll send you the PDF instantly.  You'll also receive a 10% discount code for your first Kingsyard order as a welcome gift.",
  },
  {
    question: "I'm a complete beginner. Is this guide right for me?",
    answer:
      "Absolutely. The guide starts from the very beginning — which feeder to buy first, what seed to use, where to place it — and builds up to more advanced topics like species-specific setups and seasonal care. It's designed for all experience levels.",
  },
  {
    question: 'What birds does the guide cover?',
    answer:
      'The guide focuses on the most common North American backyard bird species, including cardinals, chickadees, goldfinches, hummingbirds, bluebirds, woodpeckers, nuthatches, sparrows and more. Each species section includes feeder type, preferred food, and seasonal behaviour.',
  },
  {
    question: 'Will I receive promotional emails after signing up?',
    answer:
      "You'll receive the guide, your discount code, and occasional birding tips and product updates from Kingsyard. We send no more than 2 emails per week and you can unsubscribe at any time with a single click. We never sell or share your data.",
  },
  {
    question: 'How is this different from what I can find on Google?',
    answer:
      "It's formatted as a practical, printable reference you can keep by your feeder, not a series of web articles you have to hunt for. ",
  },
];

const FaqList = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className='mx-auto mt-10 max-w-[720px]'>
      {FAQ_DATA.map((item, index) => (
        <div
          key={index}
          className='border-b border-[#EDE9E2]'
        >
          <div
            className='flex cursor-pointer select-none items-center justify-between gap-4 py-5 font-poppins text-[18px] font-bold text-[#1a2e1b]'
            onClick={() => toggle(index)}
          >
            <span>{item.question}</span>
            <span
              className={`duration-[200ms] flex h-7 w-7 shrink-0 items-center justify-center rounded-full border text-base transition-all ${
                openIndex === index
                  ? 'rotate-45 border-primary bg-primary text-white'
                  : 'border-[#d4ead4] bg-[#F0F5F0] text-primary'
              }`}
            >
              +
            </span>
          </div>
          <div
            className={`duration-[350ms] overflow-hidden text-base leading-[1.75] text-[#444] transition-all ease-in-out ${
              openIndex === index ? 'max-h-[300px] pb-5' : 'max-h-0'
            }`}
          >
            {item.answer}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FaqList;
